/**
* Project janux-vuejs-seed
* Created by hielo on 2018-05-10
*/

<template lang="pug">
	div
		fieldset(v-for="(email,index) in data.contactMethods.emails")

			.field-title(v-if="isEmail(email.address)") E-mail Address *
			.error-val.error-contact(v-if="!isEmail(email.address)") Enter the email address *
			.each-field-contact: b-form-input.all-fields(placeholder='e-mail Address' v-model="email.address", type="email", @input="validate", :class="{errorInField: !isEmail(email.address)}")

</template>

<script>
import {EmailAddress} from 'janux-people'
const isEmail = /^(([^<>()[\]\\.,:\s@"]+(\.[^<>()[\]\\.,:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

export default {
	name: 'jnx-email',
	props: ['sectionTitle', 'data', 'isValid'],
	data () {
		return {
			mailTypes: ['PERSONAL', 'WORK', 'OTHER']
		}
	},
	methods: {
		removeEmail (index) {
			this.data.contactMethods.emails.splice(index, 1)
		},
		addNewEmail () {
			this.data.setContactMethod('work', new EmailAddress())
		},
		isEmail (value) {
			return isEmail.test(value)
		},
		validate () {
			this.isValid.email = !!(this.data.emailAddress().address && isEmail.test(this.data.emailAddress().address))
			let iterate = true
			Object.keys(this.isValid).forEach(key => {
				if (key !== 'result') {
					if (!this.isValid[key] && iterate) {
						iterate = false
						this.isValid.result = false
					} else if (this.isValid[key] && iterate) {
						this.isValid.result = true
					}
				}
			})
		}
	},
	beforeMount () {
		this.validate()
	},
	computed: {
		componentTitle () {
			return this.$t(this.sectionTitle)
		}
	}
}
</script>



// WEBPACK FOOTER //
// ../../easytitle24-2.x-common/components/party/email.vue